import Vue from 'vue'
function injectBaidu() {
  window._hmt = window._hmt_hmt || []
  ;(function() {
    var hm = document.createElement('script')
    hm.src = 'https://hm.baidu.com/hm.js?69151bdbefe3464f10c09bbe74391bea'
    var s = document.getElementsByTagName('script')[0]
    s.parentNode.insertBefore(hm, s)
  })()
}
// 处理事件统计
function tapEvent(value = {}) {
  const { type = 'funcTracker', action = 'click', opt_label = '', opt_value = 0 } = value
  window._hmt.push(['_trackEvent', type, action, opt_label, opt_value])
}
Vue.prototype.$trackevent = tapEvent
Vue.directive('trackevent', {
  // 需要传递参数：{type,opt_label,opt_value,immediate}
  bind: function(el, binding, vnode) {
    const { immediate = false } = binding.value
    if (!window._hmt) {
      injectBaidu()
    }
    if (immediate) {
      tapEvent(binding.value)
      return
    }
    el.addEventListener(
      'click',
      function(e) {
        tapEvent(binding.value)
      },
      false
    )
  }
})
